import { addDays, isoDate, weekStart } from "./schedule.js";
import { rooms } from "./rooms.js";

function event(monday, dayOffset, start, end, title) {
  const eventDate = isoDate(addDays(monday, dayOffset));
  return {
    title,
    start_date: eventDate,
    start_time: start,
    end_date: eventDate,
    end_time: end,
  };
}

export function buildDemoCache(anchor = new Date()) {
  const monday = weekStart(anchor);
  const events = Object.fromEntries(rooms.map((room) => [room.sigla, []]));

  events.EFI201 = [
    event(monday, 0, "07:30", "09:10", "-09:10. QMC5109 - 01501B (20262) [533309]"),
    event(monday, 0, "10:10", "11:50", "-11:50. MTM3103 - 04201 (20262) [532550]"),
    event(monday, 0, "13:30", "15:10", "-15:10. QMC5222 - 04205 (20262) [532551]"),
    event(monday, 0, "15:10", "17:10", "-17:10. FSC5101 - 01201A (20262) [532552]"),
    event(monday, 0, "18:30", "20:10", "-20:10. INE5111 - 04324C (20262) [532553]"),
    event(monday, 0, "20:20", "22:00", "-22:00. MTM3101 - 02318 (20262) [532554]"),
    event(monday, 1, "07:30", "10:00", "-10:00. MEN7029 - 03223 (20262) [532555]"),
    event(monday, 1, "10:10", "11:50", "-11:50. MEN5605 - 04223 (20262) [532556]"),
    event(monday, 1, "13:30", "15:10", "-15:10. QMC5223 - 04226 (20262) [532557]"),
    event(monday, 1, "15:10", "17:10", "-17:10. MTM3121 - 02226 (20262) [532558]"),
    event(monday, 2, "10:10", "11:50", "-11:50. MTM3110 - 01205 (20262) [532559]"),
    event(monday, 2, "13:30", "15:10", "-15:10. QMC5223 - 04226 (20262) [532560]"),
    event(monday, 2, "16:20", "18:00", "-18:00. MTM3104 - 04002 (20262) [532561]"),
    event(monday, 2, "18:30", "20:10", "-20:10. MTM3101 - 02318 (20262) [532562]"),
    event(monday, 3, "07:30", "10:00", "-10:00. MEN7030 - 04223 (20262) [532563]"),
    event(monday, 3, "10:10", "11:50", "-11:50. FSC5002 - 02201C (20262) [532564]"),
    event(monday, 3, "13:30", "15:10", "-15:10. FSC5101 - 01201A (20262) [532565]"),
    event(monday, 3, "18:30", "20:10", "-20:10. INE5111 - 04324C (20262) [532566]"),
    event(monday, 4, "08:20", "10:00", "-10:00. Reserva de sala [548509]"),
    event(monday, 4, "10:10", "11:50", "-11:50. FSC5121 - 03226 (20262) [532568]"),
    event(monday, 4, "13:30", "15:10", "-15:10. QMC5329 - 03226 (20262) [532569]"),
  ];

  events.AUD = [event(monday, 1, "08:20", "17:10", "-17:10. Seminário de Integração do EFI [551020]")];
  events.ANF = [event(monday, 3, "13:30", "18:00", "-18:00. Evento acadêmico [551021]")];

  rooms.filter((room) => room.tipo === "Sala de aula" && room.sigla !== "EFI201").forEach((room, index) => {
    const day = index % 5;
    const slot = index % 3;
    const starts = ["07:30", "13:30", "18:30"];
    const ends = ["09:10", "15:10", "20:10"];
    const codes = ["FSC5002", "QMC5223", "MTM3103", "INE5111", "MEN5605"];
    events[room.sigla] = [
      event(monday, day, starts[slot], ends[slot], `-${ends[slot]}. ${codes[index % codes.length]} - 0${(index % 4) + 1}20${(index % 6) + 1} (20262) [${540000 + index}]`),
    ];
  });

  return {
    updated_at: new Date().toISOString(),
    source: "demo",
    events,
  };
}
